module.exports = __webpack_public_path__ + "img/日照银行.8cfac23b.png";